import { resolveGuestCheckoutAssignment } from './ab-assignment';

export function exposeCartViewAssignment() {
  return resolveGuestCheckoutAssignment('cart_view');
}

export function exposeHeaderCartHoverAssignment() {
  return resolveGuestCheckoutAssignment('header_cart_hover');
}
